/*
 * Effets globaux du site Douze Degrés : apparition au scroll (fade-in)
 * et parallax discret. Voir assets/dd-motion.css pour les styles.
 *
 * - [data-dd-reveal] : IntersectionObserver, ajoute .is-in-view au
 *   premier passage dans le viewport puis se désabonne (apparition une
 *   seule fois).
 * - [data-dd-parallax="0.1"] : décalage vertical proportionnel à la
 *   position de l'élément par rapport au centre du viewport, mis à jour
 *   en rAF sur scroll/resize (perf : throttle via un flag "ticking").
 *
 * Les deux se désactivent si prefers-reduced-motion: reduce est actif.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('[data-dd-reveal]');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initParallax() {
    if (reduceMotion) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-dd-parallax]'));
    if (!items.length) return;

    var ticking = false;

    function update() {
      var viewportHeight = window.innerHeight;
      items.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-dd-parallax'));
        if (isNaN(speed)) speed = 0.1;
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;
        var offset = rect.top + rect.height / 2 - viewportHeight / 2;
        var translate = (offset * speed * -1).toFixed(1);
        el.style.setProperty('--dd-parallax-y', translate + 'px');
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
